module.exports = __webpack_public_path__ + "img/body-3.b8c3d6c3.png";